import { Link } from 'react-router-dom';
import type { Article } from '@/mocks/articles';

interface ArticleCardProps {
  article: Article;
}

export default function ArticleCard({ article }: ArticleCardProps) {
  return (
    <article className="group bg-background-50 rounded-lg overflow-hidden border border-background-200/70 hover:border-primary-200 transition-all duration-300">
      <Link to={`/article/${article.slug}`} className="block">
        <div className="relative overflow-hidden aspect-video">
          <img
            src={article.image}
            alt={article.title}
            className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
            loading="lazy"
          />
        </div>
        <div className="p-5">
          <div className="flex items-center gap-3 mb-3 text-xs text-foreground-500">
            <span className="inline-flex items-center gap-1 bg-accent-100 text-accent-700 px-2 py-0.5 rounded-full font-medium">
              <i className="ri-folder-line text-xs"></i>
              {article.category}
            </span>
            <span>{article.readTime} 分钟</span>
          </div>
          <h3 className="text-base font-bold text-foreground-950 mb-2 group-hover:text-primary-500 transition-colors duration-200 line-clamp-2 font-heading">
            {article.title}
          </h3>
          <p className="text-sm text-foreground-600 line-clamp-2 leading-relaxed">
            {article.excerpt}
          </p>
          <div className="flex items-center justify-between mt-4 pt-4 border-t border-background-200">
            <span className="text-xs text-foreground-400">{article.publishedAt}</span>
            <span className="inline-flex items-center gap-1 text-xs text-primary-500 font-medium group-hover:gap-2 transition-all duration-200">
              阅读全文
              <i className="ri-arrow-right-line"></i>
            </span>
          </div>
        </div>
      </Link>
    </article>
  );
}